/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus, simulationStatusActions } from '../../constants'

import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET (array of objects)
export const LIST_SIMULATION_SUCCESS = 'LIST_SIMULATION_SUCCESS'
export const LIST_SIMULATION_FAILURE = 'LIST_SIMULATION_FAILURE'

// -- CREATE
export const CREATE_SIMULATION_SUCCESS = 'CREATE_SIMULATION_SUCCESS'
export const CREATE_SIMULATION_FAILURE = 'CREATE_SIMULATION_FAILURE'

// -- DELETE
export const DELETE_SIMULATION_SUCCESS = 'DELETE_SIMULATION_SUCCESS'
export const DELETE_SIMULATION_FAILURE = 'DELETE_SIMULATION_FAILURE'

// -- CANCEL
export const CANCEL_SIMULATION_SUCCESS = 'CANCEL_SIMULATION_SUCCESS'
export const CANCEL_SIMULATION_FAILURE = 'CANCEL_SIMULATION_FAILURE'

// -- SEARCH
export const SEARCH_SIMULATIONS = 'SEARCH_SIMULATIONS'

// ____________________________________________________________

/**
 * Search for a simulation.
 *
 * @param {object} terms Text to be searched within the simulation name.
 * @returns {object}
 */
export const searchSimulations = (terms) => ({
  type: SEARCH_SIMULATIONS,
  data: terms
})

/**
 * Get the simulations list form the API and broadcast two types of events:
 * - LIST_SIMULATION_SUCCESS: in case of success
 * - LIST_SIMULATION_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project's ID.
 * @param {uuid} sid Scenario's ID.
 * @returns {Promise<object>}
 */
export const getSimulations = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SIMULATION_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] simulationsActions.getSimulations()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: LIST_SIMULATION_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: LIST_SIMULATION_FAILURE,
    data: result.data
  })
}

/**
 * Create a new simulation broadcast two types of events:
 * - CREATE_SIMULATION_SUCCESS: in case of success
 * - CREATE_SIMULATION_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project's ID.
 * @param {uuid} sid Scenario's ID.
 * @param {object} simulation Object to create in the database, Ex: { id: 123, name: '', description: '', ...}
 * @returns {Promise<object>}
 */
export const createSimulation = (pid, sid, simulation) => async (dispatch) => {
  const path = getApiPath(apiPaths.SIMULATION_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(simulation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] simulationsActions.createSimulation()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SIMULATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SIMULATION_FAILURE,
    data: result.data
  })
}

/**
 * Delete a simulation and broadcast two types of events:
 * - CANCEL_SIMULATION_SUCCESS: in case of success
 * - CANCEL_SIMULATION_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project's ID.
 * @param {uuid} sid Scenario's ID.
 * @param {object} simulation Simulation to be deleted.
 * @returns {Promise<object>}
 */
export const cancelSimulation = (pid, sid, simulation) => async (dispatch) => {
  const path = getApiPath(apiPaths.SIMULATION_CANCEL, { pid, sid, iid: simulation.id })
  const api = new Api(path)
  const result = await api.update({ status: simulationStatusActions.CANCEL })

  Logger.trace(LoggerTypes.ACTION, '[ACTION] simulationsActions.cancelSimulation()', { path, simulation, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CANCEL_SIMULATION_SUCCESS,
      data: simulation
    })
  }
  return dispatch({
    type: CANCEL_SIMULATION_FAILURE,
    data: result.data
  })
}

/**
 * Delete a simulation and broadcast two types of events:
 * - DELETE_SIMULATION_SUCCESS: in case of success
 * - DELETE_SIMULATION_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project's ID.
 * @param {uuid} sid Scenario's ID.
 * @param {object} simulation Simulation to be deleted.
 * @returns {Promise<object>}
 */
export const deleteSimulation = (pid, sid, simulation) => async (dispatch) => {
  const path = getApiPath(apiPaths.SIMULATION_DELETE, { pid, sid, iid: simulation.id })
  const api = new Api(path)
  // const result = await api.put({ status: simulationStatusActions.DELETE })
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] simulationsActions.deleteSimulation()', { path, simulation, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SIMULATION_SUCCESS,
      data: simulation
    })
  }
  return dispatch({
    type: DELETE_SIMULATION_FAILURE,
    data: result.data
  })
}

/**
 * Download the simulation logs.
 *
 * @param {uuid} pid Project's ID.
 * @param {uuid} sid Scenario's ID.
 * @param {object} simulation Simulation to be deleted.
 * @returns {Promise<object>}
 */
export const downloadSimulationLogs = (pid, sid, simulation) => async () => {
  const path = getApiPath(apiPaths.SIMULATION_DOWNLOAD_LOGS, { pid, sid, iid: simulation.id })
  const filename = `${simulation.name}.zip`
  const api = new Api(path)
  const result = await api.download(filename)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] simulationsActions.downloadSimulationLogs()', {
    path,
    simulation,
    filename,
    result
  })
}
